import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { length } from 'redux-form-validators';
import { toPlainObject, isEmpty } from 'lodash';

import {
    NAME_LENGTH,
    FIRSTNAME_LENGTH,
    EMAIL_LENGTH,
    ADDRESS_LENGTH,
    POSTCODE_LENGTH,
    CITY_LENGTH
} from '../../../../constants/form';
import {
    FormComponent,
    TextInputFieldComponent,
    EmailInputFieldComponent,
    DateInputFieldComponent,
    RadioInputFieldComponent,
    SelectFieldComponent,
    LegendFieldComponent
} from '../../../../components/form';
import { BRAND_NAME } from '../../../../constants';
import { MADAME, MONSIEUR } from '../../../../constants/civilities';
import { MOMENTJS_DATE_FORMAT_REVERSED } from '../../../../constants/moment';
import { toDate, toTimestamp, stringToMoment, nowTimestamp } from '../../../../utils/dateUtils';
import { sendProfileUpdateRequest, reset } from '../../../../services/account/myprofile/actions';

import './ProfileFormComponent.scss';

const FORM_NAME = 'profile-form';

class ProfileFormComponent extends React.Component {
    submit = formData => {
        const { sendProfileUpdateRequest, reset } = this.props;
        const {
            civility,
            lastname,
            firstname,
            address,
            postcode,
            city,
            email,
            activeMailingOffer
        } = formData;

        const birthdate = toTimestamp(stringToMoment(formData.birthdate)) * 1000;

        sendProfileUpdateRequest(
            {
                civility,
                lastname,
                firstname,
                address,
                postcode,
                city,
                birthdate,
                email,
                activeMailingOffer
            },
            () => {
                setTimeout(() => {
                    reset();
                }, 3000);
            }
        );
    };

    getCivilities = () => {
        const { i18nForm } = this.props;

        return [
            { label: i18nForm.CIVILITIES.MONSIEUR, value: MONSIEUR },
            { label: i18nForm.CIVILITIES.MADAME, value: MADAME }
        ];
    };

    validate = values => {
        const { i18nForm } = this.props;
        const errors = {};

        if (!values.civility) {
            errors.civility = i18nForm.OPTION_REQUIRED;
        }

        return errors;
    };

    render() {
        const {
            i18n,
            i18nForm,
            isAuthed,
            initialValues,
            errorMessage,
            requestSubmit,
            errorSubmit,
            successSubmit
        } = this.props;

        return (
            <FormComponent
                form={FORM_NAME}
                initialValues={isAuthed ? initialValues : {}}
                validate={this.validate}
                classNameInputContainer="grid-3 has-gutter"
                onSubmit={this.submit}
                requestSubmit={requestSubmit}
                errorSubmit={errorSubmit}
                submitText={i18n.BUTTON_VALIDATE}>
                <TextInputFieldComponent
                    name="username"
                    classNameInputContainer="one-half"
                    placeholder={i18nForm.PLACEHOLDER_USERNAME}
                    label={i18nForm.LABEL_USERNAME}
                    readOnly
                />
                <SelectFieldComponent
                    name="civility"
                    classNameInputContainer="one-quarter"
                    label={i18nForm.LABEL_CIVILITY}
                    defaultOptionLabel={i18nForm.LABEL_CIVILITY}
                    options={this.getCivilities()}
                    isRequired
                />
                <TextInputFieldComponent
                    name="lastname"
                    classNameInputContainer="one-half"
                    placeholder={i18nForm.PLACEHOLDER_LASTNAME}
                    label={i18nForm.LABEL_LASTNAME}
                    isRequired
                    validate={[
                        length({
                            max: NAME_LENGTH,
                            msg: format(i18nForm.LASTNAME_SIZE_ERROR, NAME_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="firstname"
                    classNameInputContainer="one-half"
                    placeholder={i18nForm.PLACEHOLDER_FIRSTNAME}
                    label={i18nForm.LABEL_FIRSTNAME}
                    isRequired
                    validate={[
                        length({
                            max: FIRSTNAME_LENGTH,
                            msg: format(i18nForm.FIRSTNAME_SIZE_ERROR, FIRSTNAME_LENGTH)
                        })
                    ]}
                />
                <EmailInputFieldComponent
                    name="email"
                    classNameInputContainer="one-half"
                    placeholder={i18nForm.PLACEHOLDER_EMAIL}
                    label={i18nForm.LABEL_EMAIL}
                    isRequired
                    validate={[
                        length({
                            max: EMAIL_LENGTH,
                            msg: format(i18nForm.EMAIL_SIZE_ERROR, FIRSTNAME_LENGTH)
                        })
                    ]}
                />
                <DateInputFieldComponent
                    name="birthdate"
                    classNameInputContainer="one-half"
                    label={i18nForm.LABEL_BIRTHDATE}
                    mustBeDatePast
                    max={toDate(nowTimestamp(), MOMENTJS_DATE_FORMAT_REVERSED)}
                    isRequired
                />
                <TextInputFieldComponent
                    name="address"
                    classNameInputContainer="one-half"
                    placeholder={i18nForm.LABEL_ADDRESS}
                    label={i18nForm.LABEL_ADDRESS}
                    validate={[
                        length({
                            max: ADDRESS_LENGTH,
                            msg: format(i18nForm.ADDRESS_SIZE_ERROR, ADDRESS_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="postcode"
                    classNameInputContainer="one-quarter"
                    placeholder={i18nForm.LABEL_ZIPCODE}
                    label={i18nForm.LABEL_ZIPCODE}
                    maxLength={POSTCODE_LENGTH}
                    validate={[
                        length({
                            max: POSTCODE_LENGTH,
                            msg: format(i18nForm.ZIP_CODE_SIZE_ERROR, POSTCODE_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="city"
                    classNameInputContainer="one-quarter"
                    placeholder={i18nForm.LABEL_CITY}
                    label={i18nForm.LABEL_CITY}
                    validate={[
                        length({
                            max: CITY_LENGTH,
                            msg: format(i18nForm.CITY_SIZE_ERROR, CITY_LENGTH)
                        })
                    ]}
                />
                <RadioInputFieldComponent
                    name="activeMailingOffer"
                    label={format(i18n.TEXT_NEWSLETTER, BRAND_NAME)}
                    options={[
                        { label: i18n.OPTION_YES_NEWSLETTER, value: true },
                        { label: i18n.OPTION_NO_NEWSLETTER, value: false }
                    ]}
                    classNameInputContainer="three-quarters"
                />
                <LegendFieldComponent classNameInputContainer="full txtright">
                    {i18nForm.TEXT_REQUIRED_FIELD}
                </LegendFieldComponent>
                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err message full">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
                {successSubmit && (
                    <LegendFieldComponent classNameInputContainer="color-succ form-success-message message full">
                        {i18n.SUBMIT_SUCCEEDED}
                    </LegendFieldComponent>
                )}
            </FormComponent>
        );
    }
}

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        i18nForm: state.i18n.feature.form,
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        isAuthed: !isEmpty(state.authentication.token),
        initialValues: {
            username: user.username ? user.username : '',
            civility: user.civility ? user.civility : '',
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            email: user.email ? user.email : '',
            birthdate: user.birthdate ? toDate(user.birthdate, 'YYYY-MM-DD') : null,
            address: user.address ? user.address : '',
            postcode: user.postcode ? user.postcode : '',
            city: user.city ? user.city : '',
            activeMailingOffer:
                user.activeMailingOffer && user.activeMailingOffer === true ? 'true' : 'false'
        },
        errorMessage: state.account.myprofile.error,
        requestSubmit: state.account.myprofile.fetching,
        errorSubmit: !isEmpty(state.account.myprofile.errorMessage),
        successSubmit: state.account.myprofile.successProfileUpdateRequestSubmit
    };
}

const mapDispatchtoProps = {
    sendProfileUpdateRequest,
    reset
};

export default connect(mapStateToProps, mapDispatchtoProps)(ProfileFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfileFormComponent.js